import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import EducationSection from './EducationSection';
import BasicInfoSection, { BasicInfo } from './BasicInfoSection';
import WorkExperienceSection from './WorkExperienceSection';
import { Education } from './EducationRecord';
import { WorkExperience } from './WorkExperienceRecord';
import CustomizedModal from '../common/CustomizedModal';
import ScrollToTopButton from '../common/ScrollToTopButton';
import APICaller, { MethodType } from '../common/APICaller';
import { useLoading } from '../../contexts/LoadingContext';

const emptyBasicInfo: BasicInfo = {
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  city: '',
  province: '',
  country: '',
  timezone: '',
  immigrationStatus: '',
  lgbtIdentity: '',
  ageEligibility: '',
  workEligibility: '',
  genderIdentity: '',
  visibleMinority: '',
  indigenousPerson: '',
  disability: '',
  resumeData: null,
  resumeFileName: null,
  transcriptData: null,
  transcriptFileName: null,
  linkedIn: '',
  portfolio: '',
  github: '',
  publishedPapers: '',
  wageSubsidy: '',
};

const ApplicantProfileForm: React.FC = () => {
  const [basicInfo, setBasicInfo] = useState<BasicInfo>(emptyBasicInfo);
  const [educationRecords, setEducationRecords] = useState<Education[]>([]);
  const [workExpRecords, setWorkExpRecords] = useState<WorkExperience[]>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        showLoading('Loading your profile...');
        const res = await APICaller('/profile', MethodType.GET);
        if (!res.applicantProfile) {
          setOpenModal(true);
          return;
        }
        const data = res.applicantProfile;
        const email = res.email;
        const BasicInfoData: BasicInfo = {
          id: data.id,
          firstName: data.firstName,
          lastName: data.lastName,
          email,
          city: data.city,
          province: data.province,
          country: data.country,
          timezone: data.timezone,
          immigrationStatus: data.immigrationStatus,
          lgbtIdentity: data.lgbtIdentity,
          ageEligibility: data.ageEligibility,
          workEligibility: data.workEligibility,
          genderIdentity: data.genderIdentity,
          visibleMinority: data.visibleMinority,
          indigenousPerson: data.indigenousPerson,
          disability: data.disability,
          resumeData: data.resumeData,
          resumeFileName: data.resumeFileName,
          transcriptData: data.transcriptData,
          transcriptFileName: data.transcriptFileName,
          linkedIn: data.linkedIn,
          portfolio: data.portfolio,
          github: data.github,
          publishedPapers: data.publishedPapers,
          wageSubsidy: data.wageSubsidy,
        };
        // console.log(BasicInfoData);
        setBasicInfo(BasicInfoData);
        setEducationRecords(data.education);
        setWorkExpRecords(data.workExp);
      } catch (error) {
        console.error('Error loading profile:', error);
      } finally {
        hideLoading();
      }
    };

    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const modalClickHander = async () => {
    await APICaller('/profile/applicant/create', MethodType.POST).then(res => {
      if (res.appliantId) {
        console.log(res);
      }
    });
    setOpenModal(false);
  };
  return (
    <Grid
      container
      item
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      xs={12}
      md={8}
      spacing={8}
      sx={{ paddingRight: { xs: 0, md: '15vw' }, paddingX: { xs: 2, md: 0 }, marginBottom: '5vh', paddingTop: '6vh' }}
    >
      <CustomizedModal open={openModal} clickHandler={modalClickHander} />
      <BasicInfoSection data={basicInfo} />
      <EducationSection data={educationRecords} />
      <WorkExperienceSection data={workExpRecords} />
      <ScrollToTopButton />
    </Grid>
  );
};

export default ApplicantProfileForm;
